/** Peak bytes per second the declared bus can move. */
export function derivedMemoryBandwidth(spec) {
    return spec.transferMtPerSec * 1e6 * (spec.busWidthBits / 8);
}
//# sourceMappingURL=memory-bus.js.map